import React from "react";
import './myGroups.css';
import {useSelector} from "react-redux";
import group, {GroupForm, GroupSearcher} from "../index";
import {Spinner} from "../../shared";
import GroupCard from "../groupCard/groupCard";
import {FormattedMessage, useIntl} from "react-intl";
import GroupReload from "../groupReload";
import {Helmet} from "react-helmet";
import icon from "../../../images/pageIcon.png";
import GroupInvites from "./groupInvites/groupInvites";
import users from "../../users";
import ButtonV2 from "../../shared/button-v2/button-v2";
import CustomModalV2 from "../../shared/custom-modal-v2/custom-modal-v2";

function MyGroups() {

    const userGroups = useSelector(group.selectors.userGroups);
    const darkMode = useSelector(users.selectors.isDarkMode);
    const intl = useIntl();
    const [isSearcherOpen, setIsSearcherOpen] = React.useState(false);
    const [isCreateGroupOpen, setIsCreateGroupOpen] = React.useState(false);

    if (!userGroups?.groups) {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>SquadDisk | {intl.formatMessage({id: "app.group"})}</title>
                    <link rel="icon" href={icon}/>
                </Helmet>
                <div className="d-flex flex-row justify-content-center mt-4">
                    <Spinner/>
                </div>
            </div>
        )
    }

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>SquadDisk | {intl.formatMessage({id: "app.group"})}</title>
                <link rel="icon" href={icon}/>
            </Helmet>
            <div className="d-flex flex-row justify-content-end mb-3 gap-2">
                <ButtonV2 onClick={() => setIsSearcherOpen(true)}>
                    Buscar <i className="fa-solid fa-magnifying-glass ps-2"></i>
                </ButtonV2>
                <ButtonV2 onClick={() => setIsCreateGroupOpen(true)}>
                    Crear Grupo <i className="fa-solid fa-plus ps-2"></i>
                </ButtonV2>
            </div>
            <GroupInvites groupInvites={userGroups.groupInvites}/>
            <GroupReload/>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                gap: '20px',
                padding: 8,
            }}>
                {userGroups?.groups?.map(group => {
                    return <GroupCard key={group.id} group={group} joined={true}/>
                })}
            </div>
            {!userGroups?.groups?.length &&
                <div className="alert alert-info mt-2" role="alert">
                    <FormattedMessage id="groups.no-my-groups"/>
                </div>}
            <CustomModalV2 open={isSearcherOpen} onClose={() => setIsSearcherOpen(false)}
                           title={intl.formatMessage({id: "group-search.title"})}>
                <GroupSearcher/>
            </CustomModalV2>
            <CustomModalV2 open={isCreateGroupOpen} onClose={() => setIsCreateGroupOpen(false)}
                           title={intl.formatMessage({id: "groups.create-group"})}>
                <GroupForm onSave={() => {
                    setIsCreateGroupOpen(false);
                }}/>
            </CustomModalV2>
        </div>
    )
}

export default MyGroups;
